// extracted by mini-css-extract-plugin
export default {"header":"_990f48ae","isSwiperCarousel":"_7813f931","centerTitle":"_960257da","title":"_3250f891","viewMore":"_36f4d129"};